import type { EventContentArg } from '@fullcalendar/core';
import SolarIcon from 'components/icons/SolarIcon';

type TaskCalendarEventContentProps = {
    arg: EventContentArg;
    executorLabel: string;
    controllerLabel: string;
};

const TaskCalendarEventContent = ({
    arg,
    executorLabel,
    controllerLabel,
}: TaskCalendarEventContentProps) => {
    const isExecutor = Boolean(arg.event.extendedProps.isExecutor);
    const isController = Boolean(arg.event.extendedProps.isController);
    const timeLabel = arg.timeText || String(arg.event.extendedProps.timeLabel || '');
    const categoryName = String(arg.event.extendedProps.categoryName || '');

    return (
        <span className="fc-event-task">
            <span className="fc-event-task__body">
                {timeLabel ? (
                    <span className="fc-event-task__time">{timeLabel}</span>
                ) : null}
                <span className="fc-event-task__title">{arg.event.title}</span>
                {categoryName ? (
                    <span className="fc-event-task__category">{categoryName}</span>
                ) : null}
            </span>
            {isExecutor || isController ? (
                <span className="fc-event-task__roles">
                    {isExecutor ? (
                        <SolarIcon
                            name="person"
                            className="fc-event-task__role-icon"
                            title={executorLabel}
                        />
                    ) : null}
                    {isController ? (
                        <SolarIcon
                            name="clipboard-check"
                            className="fc-event-task__role-icon"
                            title={controllerLabel}
                        />
                    ) : null}
                </span>
            ) : null}
        </span>
    );
};

export default TaskCalendarEventContent;
